import { type Enum } from '@webapp/infrastructure/types/Enum'

// Statement file format, derived from the uploaded file's extension and
// submitted as `attachment_type` when creating a statement record.
export const StatementAttachmentTypes = {
  CSV: 0, // CSV statement (goes through the importer wizard)
  QIF: 1, // QIF statement
} as const

export type StatementAttachmentType = Enum<typeof StatementAttachmentTypes>
